<template>
    
    <v-card class="elevation-10 mt-3" dense light>
      <!-- <v-card-title class="justify-center title primary darken-3">assinat!</v-card-title> -->
      
      <v-card-title class="primary lighten-2">                
          Assinatura
      </v-card-title>
      <v-card-text class="pt-10">
      
        <v-row v-if="item != null">
        
          <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
            <v-text-field
              v-model="item.ownerName"
              label="Assinante"
              prepend-icon="mdi-account"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
            <v-text-field
              v-model="item.plano.name"
              label="Plano"
              prepend-icon="mdi-ticket"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>

            <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
            <v-text-field
              v-model="item.dtCreated"
              label="Data de Processamento"
              prepend-icon="mdi-calendar-check-outline"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
            <v-text-field
              v-model="item.vencimento"
              label="Vencimento"
              prepend-icon="mdi-calendar-clock"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>

        </v-row>

        <v-row v-if="item.cobrancaApp">

          <v-col cols="12" class="title pb-8">
            <v-divider class="pb-2"></v-divider>
            Dados de Pagamento:
          </v-col>

          <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
            <v-text-field
              v-model="item.paymentMethod"
              label="Forma de Pagamento"
              prepend-icon="mdi-cash-register"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
            <v-text-field
              v-model="item.formattedPrice"
              label="Valor Pago"
              prepend-icon="mdi-cash-usd-outline"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6"  sm="12" class="pt-0 pb-0">
            <v-text-field v-if="item.paymentStatus"
              v-model="item.paymentStatus"
              label="Status do Pagamento"
              prepend-icon="mdi-file-link-outline"
              readonly
              outlined
              dense
            ></v-text-field>
            <v-text-field v-if="!item.paymentStatus"
              value="Não encontrado"
              label="Status do Pagamento"
              prepend-icon="mdi-file-link-outline"
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="title pb-8" v-if="item.paymentErrorMessage && item.paymentErrorMessage.length > 0">
            Erro ao processar o pedido:<br/>
            <span class="" style="color: red;">
              {{item.paymentErrorMessage.substring(item.paymentErrorMessage.lastIndexOf(':') + 1)}}
            </span>
          </v-col>

        </v-row>

      </v-card-text>

    </v-card>

</template>

<script>

//import axios from 'axios';
//import SnackBar from "../snackbar";


export default {
  props: {
    item : Object,
  },

  beforeMount () {

    
  },

  data: () => ({
    
    items : null,

  }),

  methods : {

    
  }
};
</script>